import './benefitCard.css'
import { useNavigate } from 'react-router-dom';

const BenefitCard = ({ benefit }) => {
  const navigate = useNavigate();
  const isEmpresa = benefit.title === 'EMPRESAS';
  const buttonText = isEmpresa ? 'Regístrate como empresa' : 'Regístrate como profesional';
  const buttonHref = isEmpresa ? '/empresas/crear' : '/profesionales/crear';

  return (
    <div className="benefit-card__container">
      <div className="benefit-card__description-container">
        <div className="benefit-card__information">
          <h3>{benefit.title}</h3>
          <div className="benefit-card__info-container">
            {benefit.descriptions.map((desc, index) => (
              <p key={index}>{desc}</p>
            ))}
          </div>
        </div>
        <div className="benefit-card__button-container">
          <button className="benefit-card__button" onClick={() => navigate(buttonHref)}>{buttonText}</button>
        </div>
      </div>
      <div className="benefit-card__image-container">
        <img src={benefit.imageUrl}></img>
      </div>
    </div>
  );
};

export default BenefitCard;
